import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const PrimaryPhoneEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ primaryPhone: event.target.value }));
  };

  return (
    <TextField
      label="Phone"
      size="small"
      fullWidth
      value={currentVendor?.primaryPhone || ''}
      onChange={handleChange}
    />
  );
};

export default PrimaryPhoneEdit;
